<script>
/** Utilities */
import * as jsPDF from 'jspdf'
import 'jspdf-autotable'; // https://github.com/simonbengtsson/jsPDF-AutoTable
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import VfeApi from '../../api/VfeApi'
/** UI Components */
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Autocomplete } from 'buefy/dist/components/autocomplete'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Checkbox } from 'buefy/dist/components/checkbox' 
import { Message } from 'buefy/dist/components/message'
import { Loading } from 'buefy/dist/components/loading'

const FOOTER_TEXT = "PH-EITI - Online Reporting in the Extractives "

export default {
    name : "SummaryView",
    components: {
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-checkbox' : Checkbox,
        'b-message' : Message,
        'b-loading' : Loading,
        'b-autocomplete' : Autocomplete
    },
    data() {
        return {
            selectedReportingYear : null,
            reportingYearLov : null,
            validatedVcards : [],
            selectedVcardId : null,
            selectedVcard : null,
            selectedVcardForms : [],
            selectedVcardLogs : [],
            isLoading : false,
            detailsLoading : false,
            vcardKeyword : ''
        }
    },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        profileHandles () {
            var repGroupIds = []
            var repEntityIds = []
            var repUnitIds = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroupIds = this.profile.reportingGroups.map(g => {
                        return g.repGroupIdFk
                    })
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntityIds = this.profile.reportingEntities.map(e => {
                        return e.repEntityIdFk
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnitIds = this.profile.reportingUnits.map(u => {
                        return u.repUnitIdFk
                    })
                }
            }
            return {
                repGroupIds,
                repEntityIds,
                repUnitIds
            }
        },
        profileHandlesData () {
            var repGroups = []
            var repEntities = []
            var repUnits = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroups = this.profile.reportingGroups
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntities = this.profile.reportingEntities.map(en => {
                        return {
                            repGroupIdFk: en.repGroupIdFk,
                            repEntityIdFk: en.repEntityIdFk,
                            repUnitIdFk: en.repUnitIdFk,
                        }
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnits = this.profile.reportingUnits.map(un => {
                        return {
                            repGroupIdFk: un.repGroupIdFk,
                            repEntityIdFk: un.repEntityIdFk,
                            repUnitIdFk: un.repUnitIdFk,
                        }
                    })
                }
            }
            return {
                repGroups,
                repEntities,
                repUnits
            }
        },
        summaryReportType(){
            if (this.selectedVcard!=null) {
                if (this.selectedVcard.reportingUnit!=null) {
                    return "Reporing Unit Report"
                }
                return "Reporting Entity Report"
            }
        },
        summaryReportName(){
            if (this.selectedVcard!=null) {
                if (this.selectedVcard.reportingUnit!=null) {
                    return this.selectedVcard.reportingUnit
                }
                return this.selectedVcard.reportingEntity
            }
        },
        summaryFileName(){
            if (this.selectedVcard!=null) {
                let name = this.selectedVcard.reportingEntity;
                if (this.selectedVcard.reportingUnit!=null) {
                    name = this.selectedVcard.reportingUnit
                }
                return (name.split(' ')).join('-');
            }
        },
        groupedForms(){
            let groupings = [], newGroupings = [];
            if (this.selectedVcardForms.length > 0) {
                this.selectedVcardForms.forEach(vform=>{
                    if (ArrayUtil.inArray(groupings,vform.groupLabelName)==false) {
                        groupings.push(vform.groupLabelName)
                    }
                });
                //////////
                groupings.forEach(grpName=>{
                    newGroupings.push({
                        groupLabelName : grpName,
                        forms: []
                    });
                    this.selectedVcardForms.forEach(vcardForm=>{
                        if (vcardForm.groupLabelName==grpName) {
                            newGroupings[newGroupings.length-1].forms.push(vcardForm);
                        }
                    });
                });
            }

            return newGroupings;
        },
        filteredVcards(){
            if (!this.vcardKeyword) {
                return this.validatedVcards;
            } 
            return this.validatedVcards.filter((option) => {
                try {
                    return option.displayedEntityName
                        .toString()
                        .toLowerCase()
                        .indexOf(this.vcardKeyword.toLowerCase()) >= 0
                }
                catch(err){
                    console.log(err)
                }
            })
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                let vcardId = '';
                                let vcardYear = null;
                                if (this.$route.query) {
                                    try {
                                        vcardId = this.$route.query.validationCardId;
                                    }
                                    catch(cardId){}   

                                    try {
                                        vcardYear = this.$route.query.reportingYear;
                                    }
                                    catch(cardId){}   
                                }
                                this.getReportingYearLov(vcardId,vcardYear);
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getReportingYearLov(vcardId,vcardYear){
            this.isLoading = true;
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();
                        if (!vcardYear) {
                            if (repYearInDb > 0) {
                                try {
                                    /* Pre-select the year with data (from DB) */ 
                                    this.selectedReportingYear = repYearInDb[0];
                                }
                                catch(yrErr){}
                            }
                        }
                        else {
                            this.selectedReportingYear = vcardYear;
                        }
                        
                        if (this.selectedReportingYear != null) {
                            this.getValidatedVcards(vcardId);
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getValidatedVcards(vcardId){
            // ValidationCardApi.getValidated(
            ValidationCardApi.getReadyValidated({
                userId : this.profile.userId,
                repGroupIdFk : this.profile.repGroupIdFk,
                repEntityIdFk : this.profile.repEntityIdFk,
                repUnitIds: this.profileHandles.repUnitIds,
                reportingYear : this.selectedReportingYear,
                repUnitData: this.profileHandlesData.repUnits,
                repGroupData: this.profileHandlesData.repGroups,
                repEntityData: this.profileHandlesData.repEntities
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        // this.validatedVcards = response.data.vcards;
                        let vcards = response.data.vcards;
                        vcards.forEach(card=>{
                            card.displayedEntityName = card.reportingUnit ? card.reportingUnit : card.reportingEntity
                        })
                        this.validatedVcards = vcards
                        // Auto-select vcard ID, if from dashboard
                        if (vcardId) {
                            this.selectedVcardId = vcardId
                            // this.selectVcard();

                            let openedVcard = vcards.filter(c=>{
                                return c.validationCardId==vcardId
                            })
                            if (openedVcard.length > 0) {
                                this.vcardKeyword = openedVcard[0].displayedEntityName
                            }
                            this.getValidationCard();
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getValidated');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getValidated');
            });
        },
        selectReportingYear(){
            this.selectedVcard = null
            this.selectedVcardId = null
            this.selectedVfe = null
            
            this.getValidatedVcards();
        },
        getValidationCard(){
            if (!this.selectedVcardId) {
                this.isLoading = false
                return false;
            }
            this.detailsLoading = true;
            this.selectedVcard = null;
            this.selectedVcardForms = [];
            this.selectedVcardLogs = [];

            ValidationCardApi.get(this.selectedVcardId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.validationCard.length == 1) {
                            /** Convert Date */
                            let currVcard = response.data.validationCard[0];
                            currVcard.dateLastUpdated = AppResourceUtil.convertDate(currVcard.dateLastUpdated)
                            currVcard.displayedEntityName = currVcard.reportingUnit ? currVcard.reportingUnit : currVcard.reportingEntity;
                            this.selectedVcard = currVcard;//response.data.validationCard[0];
                            
                            this.selectedVcard.dateGenerated = this.$moment().format('YYYY-MM-DD hh:mm:ss')
                        }

                        // this.selectedReportingYear = this.selectedValidationCard.reportingYear;
                        // this.selectedVcardForms = response.data.uniqueForms;
                        let forms = response.data.uniqueForms;
                        let vfeArr = [];
                        try {
                            if (forms.length > 0) {
                                forms.forEach(form=>{
                                    if (form.vfe.length > 0) {
                                        form.vfe.forEach(fe=>{
                                            fe.hasAnswers = null
                                            vfeArr.push({
                                                vcardFormEntryId : fe.vcardFormEntryId,
                                                formIdFk: fe.formIdFk,
                                                formDetails : form,
                                                vfe : fe
                                            })
                                        })
                                    }
                                })
                            }
                        }
                        catch(uniqueFormsErr){
                            console.log(uniqueFormsErr)
                        }
                        
                        this.selectedVcardLogs = [];
                        try {
                            if (response.data.logs.length > 0) {
                                let logs = response.data.logs;
                                logs.forEach(log=>{
                                    if (log.activityMessageLog=='Changed fields.' ||
                                        log.activityMessageLog=='Saved form entry. Changed fields.'){
                                        log['changedFields'] = JSON.parse(log.activityBody);
                                    }
                                    if (log.activityReason!=null && log.activityRequestedBy!=null) {
                                        log.additionalInfo = JSON.parse(log.activityBody);
                                    }
                                    /** Convert date */
                                    log.activityDate = AppResourceUtil.convertDate(log.activityDate)
                                });
                                this.selectedVcardLogs = logs;
                            }
                        }
                        catch(vcardLogsErr){
                            console.log(vcardLogsErr)
                        }
                        this.getFormFields(vfeArr,forms);
                    }
                    else {
                        this.isLoading = false;
                        this.detailsLoading = false;
                        this.promptServerError({response},'ValidationCard.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.detailsLoading = false;
                this.promptServerError(error,'ValidationCard.get');
            });
        },
        getFormFields(vfeArr,forms){
            
            if (vfeArr.length > 0) {

                let promisesArr = [];

                vfeArr.forEach(data=>{
                    promisesArr.push(
                        VfeApi.get(data.vcardFormEntryId,data.formIdFk)
                    )
                });

                Promise.all(promisesArr)
                .then(results=>{
                    if (results.length > 0) {
                        try {
                            results.forEach(response=>{
                                if (response.config) {

                                    // Get for which form are we getting the fields and answers
                                    let requestUrl = response.config.url;
                                    let urlParam = requestUrl.split('?')
                                    let params = urlParam[urlParam.length-1].split('&');

                                    let vfeDetail = {};
                                    try {
                                        if (params.length) {
                                            params.forEach(param=>{
                                                let field = param.split('=')[0];
                                                let value = param.split('=')[1];
                                                vfeDetail[field] = value;
                                            });
                                        }
                                    }
                                    catch(vfeDetailParamErr){
                                        console.log(vfeDetailParamErr)
                                    }

                                    try {
                                        let formGroup = forms.filter(form=>{
                                            return (form.formIdFk==vfeDetail.formIdFk)
                                        })
                                        if (formGroup.length > 0) {
                                            if (formGroup[0].vfe.length > 0) {
                                                formGroup[0].vfe.forEach(cvfe=>{
                                                    if (cvfe.vcardFormEntryId==vfeDetail.vcardFormEntryId && cvfe.formIdFk==vfeDetail.formIdFk) {
                                                        if (response.data) {
                                                            if (!response.data.error) {
                                                                cvfe.hasAnswers = response.data.hasAnswers
                                                                cvfe.fields = response.data.fields;
                                                                // console.log(cvfe.fields)

                                                                let currFieldGroup = "";
                                                                cvfe.groupedFields = [];
                                                                cvfe.fields.forEach(field=>{
                                                                    if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                                                                        cvfe.groupedFields[cvfe.groupedFields.length-1].fields.push(field)
                                                                    }
                                                                    else {
                                                                        cvfe.groupedFields.push({
                                                                            fieldGroupName: field.fieldGroupLabel,
                                                                            fields : [field]
                                                                        })
                                                                    }
                                                                    currFieldGroup = field.fieldGroupLabel;
                                                                });
                                                            }
                                                            else {
                                                                // Prompt & return to break forEach loop
                                                            }
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    }
                                    catch(formGroupErr){
                                        console.log(formGroupErr)
                                    }
                                }
                            });
                        }
                        catch(resultErr){
                            console.log(resultErr)
                        }
                        this.isLoading = false;
                        this.detailsLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.detailsLoading = false;
                    }
                    this.selectedVcardForms = forms;
                })
                .catch(error=>{
                    this.isLoading = false;
                    this.detailsLoading = false;
                });
            }
        },
        selectVcard(option){
            if (option) {
                this.selectedVcardId = option.validationCardId
                this.vcardKeyword = option.displayedEntityName
            }
            else {
                this.selectedVcardId = null
            }
            if (this.selectedVcardId!=null) {
                // Get All Forms under this vcard
                // Get All Fields and then list the answers
                this.getValidationCard();
            }
        },
        onlyUnique(value, index, self) { 
            return self.indexOf(value) === index;
        },
        exportToPdf(){
            const _gray1_ = "#ababab"; // also field group label
            const _gray2_ = "#9b9b9b"; // <hr> color
            const _gray3_ = "#414042"; // dark gray

            var doc = new jsPDF({
                orientation: 'landscape',
                format: 'legal'
            });

            // Build header
            doc.setFontStyle("normal");
            doc.setTextColor(_gray1_)
            doc.setFontSize(10)
            doc.text(this.summaryReportType.toUpperCase(),15,22);

            doc.setFontSize(12)
            doc.setTextColor(_gray3_)
            doc.setFontStyle("bold");
            doc.text('Category: ',15,29);
            doc.setFontStyle("normal");
            doc.text(this.selectedVcard.reportingGroup,50,29);

            doc.setFont("times");
            doc.setFontStyle("bold");
            doc.setFontSize(16);
            doc.text(this.summaryReportName,15,36);
            
            doc.setFont("helvetica");
            doc.setFontStyle("bold");
            doc.setFontSize(9)
            doc.text('Date last updated: ',15,42);

            doc.setFontStyle("normal");
            doc.text(this.selectedVcard.dateLastUpdated,50,42);

            doc.setFontStyle("bold");
            doc.text('Date generated: ',15,47);

            doc.setFontStyle("normal");
            doc.text(this.selectedVcard.dateGenerated,50,47);
            // End Header

            let yStart = 50;
            let xStart = 15;
            
            if (this.groupedForms.length > 0) {

                /** Iterate on groupings/labels */
                this.groupedForms.forEach((group,groupIdx)=>{

                    if (group.groupLabelName!=null) {
                        doc.setFont('helvetica');
                        doc.setFontStyle("normal");
                        doc.setTextColor(_gray3_);
                        doc.setFontSize(13);

                        if (yStart > 250) {
                            doc.addPage();
                            yStart = 22;
                        }

                        doc.text(group.groupLabelName,xStart,yStart+8);
                        yStart = yStart + 8;
                    }

                    /** Iterate forms under current grouping label */
                    group.forms.forEach((form,formIdx) => {
                
                        doc.setFont('times');
                        doc.setFontStyle("normal");
                        doc.setTextColor(_gray3_);
                        doc.setFontSize(12);

                        if (yStart > 250) {
                            doc.addPage();
                            yStart = 22;
                        }

                        doc.text(form.formName,xStart,yStart+8);
                        yStart = yStart + 8;

                        // If displayOption=='List'
                        if (form.displayOption=='List') {   

                            if (form.vfe.length > 0) {

                                form.vfe.forEach(lvfe=>{

                                    if (lvfe.groupedFields && lvfe.groupedFields.length > 0) {

                                        yStart = yStart + 8;

                                        if (yStart > 250) {
                                            doc.addPage();
                                            yStart = 22;
                                        }

                                        lvfe.groupedFields.forEach((fgrp,fgrpIdx)=>{
   
                                            if (fgrp.fields.length > 0 && fgrp.fieldGroupName=='') {
                                            
                                                doc.autoTable({
                                                    theme: 'grid',
                                                    columnStyles: {
                                                        0: {halign: 'left', cellWidth: 65}
                                                    },
                                                    startY: yStart,
                                                    pageBreak : 'avoid',
                                                    rowPageBreak : 'avoid',
                                                    html: `#vfe-${lvfe.vcardFormEntryId}-summary-list-ungrp-${groupIdx}-${formIdx}-${fgrpIdx}`
                                                });
                                                yStart = doc.lastAutoTable.finalY;

                                            }
                                            else if (fgrp.fields.length > 0 && fgrp.fieldGroupName!='') { 

                                                doc.autoTable({
                                                    theme: 'grid',
                                                    headStyles : { 
                                                        fillColor: null, 
                                                        textColor: [65,64,66], 
                                                        lineWidth : 0.3, 
                                                        lineColor: [214,214,214] 
                                                    },
                                                    columnStyles: {
                                                        0: {halign: 'left', cellWidth: 65}
                                                    },
                                                    startY: yStart,
                                                    pageBreak : 'avoid',
                                                    rowPageBreak : 'avoid',
                                                    html: `#vfe-${lvfe.vcardFormEntryId}-summary-list-grp-${groupIdx}-${formIdx}-${fgrpIdx}`
                                                });

                                                yStart = doc.lastAutoTable.finalY;

                                            }

                                        });

                                    }
                                });

                            }

                        }
                        else {
                            // If displayOption=='Table'
                            if (yStart > 250) {
                                doc.addPage();
                                yStart = 22;
                            }
                            
                            var tableDataOptions = {}
                            /** Custom for 2019 forms */
                            if (form.formName === 'Economic Linkages and Outside Services') {
                                tableDataOptions = {
                                    theme: 'grid',
                                    startY:  yStart + 8,
                                    headStyles : { 
                                        fillColor: null, 
                                        textColor: [65,64,66], 
                                        lineWidth : 0.3, 
                                        lineColor: [214,214,214] 
                                    },
                                    columnStyles: {
                                        0: { cellWidth: 33},
                                        2: { cellWidth: 33},
                                        4: { cellWidth: 22}
                                    },
                                    pageBreak : 'avoid',
                                    rowPageBreak : 'avoid',
                                    html: '#summary-table-'+groupIdx+"-"+formIdx
                                }
                            } else if (form.formName === 'COVID-19 Response') {
                                tableDataOptions = {
                                    theme: 'grid',
                                    startY:  yStart + 8,
                                    headStyles : { 
                                        fillColor: null, 
                                        textColor: [65,64,66], 
                                        lineWidth : 0.3, 
                                        lineColor: [214,214,214] 
                                    },
                                    columnStyles: {
                                        0: { cellWidth: 25},
                                        1: { cellWidth: 25},
                                        2: { cellWidth: 25},
                                        3: { cellWidth: 17},
                                        4: { cellWidth: 17},
                                        5: { cellWidth: 17},
                                        6: { cellWidth: 17},
                                        7: { cellWidth: 23},
                                        8: { cellWidth: 23}
                                    },
                                    pageBreak : 'avoid',
                                    rowPageBreak : 'avoid',
                                    html: '#summary-table-'+groupIdx+"-"+formIdx
                                }
                            } else {
                                tableDataOptions = {
                                    theme: 'grid',
                                    startY:  yStart + 8,
                                    headStyles : { 
                                        fillColor: null, 
                                        textColor: [65,64,66], 
                                        lineWidth : 0.3, 
                                        lineColor: [214,214,214] 
                                    },
                                    pageBreak : 'avoid',
                                    rowPageBreak : 'avoid',
                                    html: '#summary-table-'+groupIdx+"-"+formIdx
                                }
                            }
                            doc.autoTable(tableDataOptions)                            
                            yStart = doc.lastAutoTable.finalY;

                        }

                    });
                });
            } 

            var pageCount = doc.internal.getNumberOfPages();
            for(let i = 0; i < pageCount; i++) { 
                doc.setPage(i); 
                doc.setTextColor(_gray1_)
                doc.setFont("helvetica");
                doc.setFontSize(9)
                doc.text(15,285, FOOTER_TEXT+' | Page '+doc.internal.getCurrentPageInfo().pageNumber);
            }

            doc.save(this.summaryFileName+'_'+this.$moment().format('x')+'.pdf');
        },
        exportToCsv(){},
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Summary</p>

        <!-- Reporting Year Selection -->
        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                        
                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="validatedVcards.length > 0"
                    style="width:300px"> 
                    
                    <b-autocomplete
                        icon="magnify"
                        placeholder="Choose Validation Card"
                        v-model="vcardKeyword"
                        v-bind:data="filteredVcards"
                        v-bind:open-on-focus="true"
                        v-on:select="selectVcard"
                        :clearable="true"
                        field="displayedEntityName"
                        :max-height="'280px'">
                        <template slot-scope="props">
                            <span class="title is-6">{{props.option.displayedEntityName}}</span><br/>
                            <span class="has-text-weight-ligh">{{props.option.reportingGroup}}</span><br/>
                            <span class="tag"
                                v-bind:class="'tag--'+props.option.validationCardStatusClass">{{props.option.validationCardStatus}}</span>
                        </template>
                        <template slot="empty">No results found</template>
                    </b-autocomplete>

                    <!-- <b-dropdown 
                        v-model="selectedVcardId" 
                        aria-role="list">
                        <button class="button is-primary" type="button" slot="trigger">
                            <template v-if="summaryReportName">
                                <span>{{summaryReportName}}</span>
                            </template>
                            <template v-else>
                                <span>Choose Validation Card</span>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                    
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-for="vcard in validatedVcards"
                            v-bind:key="vcard.validationCardId"
                            v-bind:value="vcard.validationCardId"
                            v-on:click="selectVcard">
                            <div class="media">
                                <div class="media-content">
                                    <h3 class="has-text-weight-semibold">{{vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity}}</h3>
                                    <small>{{vcard.cardLevel}}</small>
                                </div>
                            </div>
                        </b-dropdown-item>

                    </b-dropdown> -->
                </div>
                <div class="control"
                    v-if="selectedVcardId">
                    
                    <button class="button is-info"
                        type="button"
                        v-on:click="exportToPdf">
                        <span class="icon">
                            <i class="fas fa-file-download"></i>
                        </span>
                        <span>Export to PDF</span>
                    </button>

                    <!-- Uncomment if export to csv is enabled already 
                    <b-dropdown aria-role="list">
                        <button class="button is-info" slot="trigger">
                            <span class="icon">
                                <i class="fas fa-file-download"></i>
                            </span>
                            <span>Export summary as</span>
                            <b-icon icon="menu-down"></b-icon>
                        </button>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="exportToPdf">
                            <span class="has-text-semi-bold">.pdf</span>
                        </b-dropdown-item>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="exportToCsv">
                            <span class="has-text-semi-bold">.csv</span>
                        </b-dropdown-item>
                    </b-dropdown> -->
                </div>
            </div>
        </div>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="false" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading</span>
            </b-loading>
        </section>

        <section class="section no-padd--top app-view app-view--user"
            v-if="selectedVcard!=null && !isLoading"
            style="padding-top:1rem;">
            
            <div class="columns"
                style="margin-top:0.5rem;">
                
                <div class="column box">
                    <p class="title is-4">SUMMARY</p>
                    <div class="summary-container">
                        <span class="heading">{{summaryReportType}}</span>
                        
                        <!-- Heading -->
                        <table class="summary-table-info">
                            <tr>
                                <td>
                                    <span class="subtitle">Category</span>
                                </td>
                                <td>
                                    <span class="subtitle">{{selectedVcard.reportingGroup}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <p class="title">{{summaryReportName}}
                                        <span class="tag"
                                            v-bind:class="'tag--'+selectedVcard.validationCardStatusClass">{{selectedVcard.validationCardStatus}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Date last updated:
                                </td>
                                <td>
                                    {{selectedVcard.dateLastUpdated}}
                                </td>
                            </tr>
                            <tr>
                                <td>Date generated</td>
                                <td>
                                    {{selectedVcard.dateGenerated}}
                                </td>
                            </tr>
                        </table>

                        <section class="base-box--loading"
                            v-if="detailsLoading">
                            <b-loading 
                                v-bind:is-full-page="false" 
                                v-bind:active.sync="detailsLoading"
                                >
                                <b-icon
                                    pack="fas"
                                    icon="sync-alt"
                                    size="is-medium"
                                    custom-class="fa-spin">
                                </b-icon>
                                &nbsp;&nbsp;&nbsp;
                                <span class="title is-5">Loading</span>
                            </b-loading>
                        </section>

                        <!-- Forms -->
                        <div v-if="!detailsLoading && selectedVcardForms.length > 0 && groupedForms.length > 0"
                            class="list-container">

                            <ul class="group-list">
                                <li
                                    v-for="(group,groupIdx) in groupedForms"
                                    v-bind:key="groupIdx">

                                    <h3 class="subtitle is-4"
                                        v-if="group.groupLabelName!=null">&nbsp;{{group.groupLabelName}}</h3>

                                    <ul class="form-list">
                                        <li v-for="(uform,uformIdx) in group.forms"
                                            v-bind:key="uformIdx">

                                            <hr class="form-divider"/>
                                            <h3 class="subtitle is-5">{{uform.formName}}</h3>
                                            
                                            <!-- Each VFE -->

                                            <div v-if="uform.displayOption=='List'">
                                                <div v-if="uform.vfe && uform.vfe.length > 0">
                                                    <div
                                                        v-for="vfe in uform.vfe"
                                                        v-bind:key="vfe.vcardFormEntryId"
                                                        class="vfe-list">

                                                        <!-- If display option is 'List' -->
                                                        <div v-if="vfe.groupedFields && vfe.groupedFields.length > 0">
                                                            <div v-for="(grp,grpIdx) in vfe.groupedFields"
                                                                v-bind:key="grpIdx">

                                                                <table 
                                                                    class="vfe-table vfe-table--grp"
                                                                    v-if="grp.fields && grp.fields.length > 0 && grp.fieldGroupName!=''"
                                                                    v-bind:id="`vfe-${vfe.vcardFormEntryId}-summary-list-grp-${groupIdx}-${uformIdx}-${grpIdx}`">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="padding-left:0.5rem;">
                                                                                <strong>{{grp.fieldGroupName}}</strong>
                                                                            </th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr 
                                                                            v-for="(field,fieldIdx) in grp.fields"
                                                                            v-bind:key="fieldIdx">
                                                                            <td style="padding-left:0.6rem;">
                                                                                <span>{{field.fieldLabel}}:</span>
                                                                            </td>
                                                                            <td>
                                                                                {{field.fieldAnswerLabel}}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                                <table 
                                                                    class="vfe-table"
                                                                    v-if="grp.fields && grp.fields.length > 0 && grp.fieldGroupName==''"
                                                                    v-bind:id="`vfe-${vfe.vcardFormEntryId}-summary-list-ungrp-${groupIdx}-${uformIdx}-${grpIdx}`">
                                                                    <tbody>
                                                                        <tr 
                                                                            v-for="(field,fieldIdx) in grp.fields"
                                                                            v-bind:key="fieldIdx">
                                                                            <td>
                                                                                <strong>{{field.fieldLabel}}:</strong>
                                                                            </td>
                                                                            <td>
                                                                                {{field.fieldAnswerLabel}}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- If display option is 'table' -->
                                            <div v-if="uform.displayOption=='Table'"
                                                class="summary-table-view">
                                                
                                                <table class="ore-table"
                                                    v-bind:id="'summary-table-'+groupIdx+'-'+uformIdx">
                                                    <thead>
                                                        <tr>
                                                            <th v-for="(col,colIdx) in uform.fieldsForSummary"
                                                                v-bind:key="colIdx"
                                                                style="min-width:100px;max-width:200px;">
                                                                <span v-if="col.fieldGroupLabel">{{col.fieldGroupLabel}} - </span>
                                                                {{col.fieldLabel}} <span v-if="col.fieldSubLabel">{{col.fieldSubLabel}}</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody 
                                                        v-if="uform && uform.vfe.length > 0">
                                                        <tr v-for="(vfe,vfeIdx) in uform.vfe"
                                                            v-bind:key="vfeIdx">
                                                            <td v-for="(col,colIdx) in vfe.fields"
                                                                v-bind:key="colIdx"
                                                                style="min-width:100px;max-width:200px;">
                                                                {{col.fieldAnswerLabel}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>

                                        </li>
                                    </ul>

                                </li>
                            </ul> 

                        </div>
                    </div>

                </div>

                <div class="column is-5"
                    style="padding-left:2em;">
                    <p class="title is-4">LOGS</p>
                    <p class="is-italic has-text-info">*NOTE: Logs are not included in export.</p> <br/>

                    <div v-if="selectedVcardLogs.length==0"
                        class="base-box  box-hw--fill base-box--padded empty-state-box">
                        <p class="title has-text-grey-light">No logs found</p>
                    </div>
                    <div v-if="selectedVcardLogs.length > 0">
                        <div class="timeline">
                            <!-- Show this if status is validated and submitted already -->
                            <header class="timeline-header"
                                v-if="selectedVcard && selectedVcard.validationCardStatus=='Validated and Submitted'">
                                <span class="tag is-medium is-dark">End </span>
                            </header>
                            <div class="timeline-item"
                                v-for="log in selectedVcardLogs"
                                v-bind:key="log.logId">
                                <div class="timeline-marker">
                                    <!-- <div class="timeline-marker is-image is-32x32"> 
                                            <img src="http://bulma.io/images/placeholders/32x32.png"> -->
                                    <!-- <div class="timeline-marker is-icon">
                                        <i class="fa fa-flag"></i> -->
                                </div>
                                <div class="timeline-content">
                                    <p class="heading">{{log.activityDate}} by {{log.activityByUserName}}</p>
                                    <p>{{log.activityMessageLog}}</p>
                                    <p
                                        v-if="log.additionalInfo"
                                        class="is-italic">
                                        {{log.additionalInfo.activity}}
                                    </p>
                                    <p
                                        v-if="log.activityReason">
                                        <strong>Reason :</strong> {{log.activityReason}}
                                    </p>
                                    <p v-if="log.activitySection=='Validation Card - Form Entry'"><span class="has-text-weight-bold">Form Name:</span> {{log.formName}}</p>
                                    <div v-if="log.activityBody && !log.activityReason">
                                        <table 
                                            width="100%"
                                            cellpadding="5"
                                            cellspacing="6"
                                            class="activity-log-table"
                                            v-if="log.changedFields">
                                            <thead>
                                                <tr>

                                                    <th>Field</th>
                                                    <th>Old Value</th>
                                                    <th>New Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr 
                                                    v-for="(ch,chIdx) in log.changedFields"
                                                    v-bind:key="chIdx">
                                                    <td>{{ch.fieldLabel}}</td>
                                                    <td>
                                                        <span class="strikethrough">{{ch.oldValue}}</span>
                                                    </td>
                                                    <td>{{ch.newValue}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p v-else
                                            class="is-italic">
                                            {{log.activityBody}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <header class="timeline-header">
                                <span class="tag is-medium is-dark">Start</span>
                            </header>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        
        <!-- Empty State -->
        <section class="section no-padd--top app-view app-view--user"
            v-if="!selectedVcardId && !isLoading">
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" >
                <div class="has-text-centered"
                    v-if="validatedVcards.length > 0">
                    <p class="title is-5">There's no selected validation card.</p>
                    <p class="subtitle">To get started, select from the dropdown next to Reporting Year.</p>
                </div>
                <div class="has-text-centered"
                    v-if="validatedVcards.length == 0">
                    <p class="title is-5">There are no validation cards that are 'Validated and Submitted' for the selected reporting year.</p>
                </div>
            </div>   
        </section>
    </section> 
</template>

<style scoped>
.summary-table-info td {
    padding: 0.3em;
}
.list-container {
    margin-top: 2em;
}
.group-list li {
    margin-top: 1em;
}
.group-list li:first-child {
    margin-top: 0px;
}
.form-list {
    padding-left: 1em;
}
.form-list > li {
    padding-top:1em;
}
.vfe-table {
    border-collapse:collapse;
    width:600px;
    margin-top:0.35em;
    margin-left:0.5em;
}
.vfe-list {
    width: auto; /*610px;*/
    border:none;
    /* background-color: whitesmoke; */
    border-bottom: 1px dotted #e5e5e5;
}
.vfe-list:last-child {
    border-bottom: none;
}
.vfe-table td {
    padding-top: 0.35em;
    padding-bottom: 0.35em;
}
.vfe-table td:first-child {
    width: 50%;
    padding-right: 1em;
}
.vfe-table tr:last-child > td {
    padding-bottom: 0.8em;
}
fieldset {
    margin-top:1em;
    margin-left:0.5em;
}
fieldset .subtitle {
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.vfe-table.vfe-table--grp {
    margin-top: 8px;
    margin-bottom: 0.5em;
    margin-left: 0px;
}
.vfe-table.vfe-table--grp td {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
}
.vfe-table.vfe-table--grp td:last-child {
    padding-left: 0.4em;
}
.summary-table-view {
    max-width:100vh;
    overflow-y:scroll;
}
.form-divider {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/summary/SummaryView.vue